import React from "react";
import { useCruise } from "../context/CruiseContext";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { HelpCircle, Phone } from "lucide-react";
import { useLocation } from "react-router-dom";
import { Button } from "./ui/button";
import faqByRoute from "../seo/faq.json";

const FAQ = () => {
  const { FAQS: cruiseFaqs, EVENT } = useCruise();
  const route = useLocation().pathname.replace(/\/+$/, "");
  const FAQS = [...(faqByRoute[route] || []), ...cruiseFaqs];
  return (
    <section id="faq" className="relative bg-[#111111] py-24">
      <div className="max-w-4xl mx-auto px-5">
        <div className="text-center mb-14">
          <p className="font-cond uppercase tracking-[0.4em] text-[#E50914] text-sm mb-3">Good To Know</p>
          <h2 className="font-display uppercase text-white text-4xl sm:text-6xl">
            Frequently Asked <span className="text-[#E50914]">Questions</span>
          </h2>
          <div className="flex justify-center mt-4">
            <span className="section-line" />
          </div>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border border-white/10 rounded-xl bg-[#1A1A1A] px-5 data-[state=open]:border-[#E50914]/60 transition-colors"
            >
              <AccordionTrigger className="text-left font-cond uppercase tracking-wide text-white text-base hover:no-underline py-5">
                <span className="flex items-center gap-3">
                  <HelpCircle size={18} className="text-[var(--hh-gold)] shrink-0" />
                  {item.q}
                </span>
              </AccordionTrigger>
              <AccordionContent className="text-white/65 text-[15px] leading-relaxed pb-5 pl-9">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-12 text-center bg-[#1A1A1A] border border-white/10 rounded-2xl p-8">
          <p className="font-cond uppercase tracking-widest text-white text-lg mb-2">Still have questions?</p>
          <p className="text-white/55 mb-6">Our team is happy to help you plan the perfect getaway.</p>
          <a href={EVENT.phoneHref}>
            <Button className="bg-[#E50914] hover:bg-[#c20710] text-white font-cond uppercase tracking-widest rounded-full px-8 py-6 h-auto">
              <Phone size={18} className="mr-2" /> Call {EVENT.phone}
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
